import React from 'react'
import PropTypes from 'prop-types'
import { tei } from '@Root/tei'
import { FederationApplicationForm } from './variants/FederationApplicationForm'
import { TrinityApplicationForm } from './variants/TrinityApplicationForm'
import { StMellitusApplicationForm } from './variants/StMellitusApplicationForm'

/**
 * Read-only view of a legacy (pre-Cognito) application. Each TEI ran its own paper form, so the
 * layouts differ in sections and wording, not just in fields.
 *
 * ponytail: the three legacy layouts are kept as whole variants instead of one field-driven component.
 * They are frozen (new applications come through Cognito Forms), so the ceiling is "one file per layout".
 * Picked by TEI slug first, then by profile.
 */
const VARIANTS = {
  federation: FederationApplicationForm,
  trinity: TrinityApplicationForm,
  stmellitus: StMellitusApplicationForm,
}

export const ApplicationForm = props => {
  const { slug, profile } = tei()
  const Variant = VARIANTS[slug] || VARIANTS[profile] || StMellitusApplicationForm

  return <Variant {...props} />
}

ApplicationForm.propTypes = {
  data: PropTypes.object,
}
